import { Controller } from "@hotwired/stimulus"
import { Chart, registerables } from "chart.js"

// Register all Chart.js components
Chart.register(...registerables)

// Set default font and colors
Chart.defaults.font.family = "'Inter', 'system-ui', 'sans-serif'"
Chart.defaults.color = "#6b7280"

export default class extends Controller {
  static values = {
    type: String,
    data: Object,
    options: Object
  }

  connect() {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      this.createChart()
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }

  createChart() {
    // Destroy existing chart if any (handles Turbo cache)
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }

    const ctx = this.element.getContext("2d")
    if (!ctx) {
      console.error("Could not get canvas context")
      return
    }

    // Parse data if it's a string (shouldn't be needed but safety check)
    let chartData = this.dataValue
    if (typeof chartData === "string") {
      try {
        chartData = JSON.parse(chartData)
      } catch (e) {
        console.error("Failed to parse chart data:", e)
        return
      }
    }

    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: chartData,
      options: this.mergeOptions()
    })
  }

  mergeOptions() {
    const defaultOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "bottom",
          labels: {
            padding: 20,
            usePointStyle: true
          }
        },
        tooltip: {
          backgroundColor: "rgba(17, 24, 39, 0.9)",
          padding: 12,
          cornerRadius: 8,
          titleFont: { size: 14, weight: "600" },
          bodyFont: { size: 13 }
        }
      }
    }

    return { ...defaultOptions, ...this.optionsValue }
  }
}
